import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout';

Vue.component(CollapseTransition.name, CollapseTransition);
Vue.use(Router);

export const constantRoutes = [
    {
        path: '/login',
        component: () => import('@/views/login/index'),
        hidden: true,
    },
    {
        path: '/',
        component: Layout,
        redirect: '/chat',
        meta: { title: 'Carebot', isSingle: true },
        children: [
            {
                path: '/chat',
                component: () => import('@/views/carebot/chat'),
                name: 'careBotChat',
                hidden: true,
                props: true,
                meta: { title: ['问答'], activeMenu: '' },
            },
        ],
    },
    {
        path: '/register',
        component: () => import('@/views/carebot/register'),
        hidden: true,
    },
];

const createRouter = () =>
    new Router({
        scrollBehavior: () => ({ y: 0 }),
        routes: constantRoutes,
    });

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js